import React, { useState, useMemo } from 'react';
import { Range } from 'react-range';
import LinearGradientHelper from '../LinearGradientHelper';

import "./AdvanceSliders.scss"

export function TemperatureSlider({ min, max, initalValue, step, onChange }) {
    return <GeneralSlider
        min={min} max={max} initalValue={initalValue} step={step} onChange={onChange}
        backBackground="linear-gradient(90deg, #23D3FE33 0%, #FF470033 100%)"
        frontBackground="linear-gradient(90deg, #23D3FE 0%, #FF4700 100%)"
        thumbGradColors={[['#23D3FE', 0], ['#FF4700', 1]]}
        formatLabel={(value) => value.toFixed(0) + "˚C"}
        showSteps={false}
    />
};

export function HumiditySlider({ min, max, initalValue, step, onChange }) {
    return <GeneralSlider
        min={min} max={max} initalValue={initalValue} step={step} onChange={onChange}
        backBackground="linear-gradient(90deg, #FAD73533 0%, #B6C94233 23.44%, #78BC4D33 27.6%, #78BC4D33 49.48%, #0F87A933 56.25%, #0F87A933 100%)"
        frontBackground="linear-gradient(90deg, #FAD735 0%, #B6C942 23.44%, #78BC4D 27.6%, #78BC4D 49.48%, #0F87A9 56.25%, #0F87A9 100%)"
        thumbGradColors={[['#FAD735', 0], ['#B6C942', .2344], ['#78BC4D', .276], ['#55B353', .4948], ['#0F87A9', .5625], ['#08609C', 1],]}
        formatLabel={(value) => value.toFixed(0) + "%"}
        showSteps={false}
    />
};

export function BrightnessSlider({ min, max, initalValue, step, onChange, lightLevels }) {
    return <GeneralSlider
        min={min} max={max} initalValue={initalValue} step={step} onChange={onChange}
        backBackground="linear-gradient(90deg, #74747433 0%, #FFFFFF33 100%)"
        frontBackground="linear-gradient(90deg, #747474 0%, #FFFFFF 100%)"
        thumbGradColors={[['#747474', 0], ['#FFF', 1],]}
        formatLabel={(value) => lightLevels[value]}
        showSteps={true} stepBackColor="#8A8A8A" stepFrontColor="#000000"
    />
};

function GeneralSlider({
    min, max, initalValue, step, onChange,
    backBackground, frontBackground, thumbGradColors, formatLabel,
    showSteps, stepBackColor, stepFrontColor
}) {
    const [values, setValues] = useState([initalValue]);

    const progress = (values[0] - min) / (max - min);
    const progressIStr = String(100 - ((values[0] - min) / (max - min) * 100));
    const progressMask = "linear-gradient(-90deg, transparent 0%, transparent " + progressIStr + "%, black " + progressIStr + "%, black 100%)"

    const frontGrad = useMemo(() => {
        return new LinearGradientHelper(thumbGradColors);
    }, [thumbGradColors]);
    const thumbColor = useMemo(() => {
        return frontGrad.getColor(progress * 100);
    }, [frontGrad, progress]);

    const stepCount = (max - min) + 1;
    const stepFirstBackIndex = values[0] - min;

    return (
        <Range
            values={values}
            step={step}
            min={min}
            max={max}
            rtl={false}
            onChange={(values) => setValues(values)}
            onFinalChange={(values) => {onChange(values[0])}}
            renderTrack={({ props, children }) => (
                <div
                    onMouseDown={props.onMouseDown}
                    onTouchStart={props.onTouchStart}
                    ref={props.ref}
                    className='advance-slider-track'
                    style={{
                        ...props.style,
                    }}
                >
                    <div
                        className='back'
                        style={{
                            background: backBackground,
                        }}
                    />
                    <div
                        className='front'
                        style={{
                            background: frontBackground,
                            maskImage: progressMask,
                            WebkitMaskImage: progressMask,
                        }}
                    />
                    <div className='labels'>
                        <div>{formatLabel(min)}</div>
                        <div />
                        <div>{formatLabel(max)}</div>
                    </div>
                    {showSteps ? <div className='steps'>
                        {Array.from(Array(stepCount).keys()).map(
                            (index) =>
                                <div className='step' style={{
                                    backgroundColor:
                                        ((index === 0) || (index === stepCount - 1)) ? "transparent" :
                                            (index < stepFirstBackIndex) ? stepFrontColor : stepBackColor
                                }} key={`key-slider-step-${index}`} />
                        )}
                    </div> : null}
                    {children}
                </div>
            )}
            renderThumb={({ props, isDragged }) => (
                <div
                    {...props}
                    className='thumb'
                    style={{
                        ...props.style,
                        backgroundColor: thumbColor,
                    }}
                >
                    <div className='label'>
                        {formatLabel(values[0])}
                    </div>
                </div>
            )}
        />
    );
};
